var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDryspellIconWeekend(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 250 250",
    style: {
      enableBackground: "new 0 0 250 250"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M226.4,31.7L226.4,31.7c0-0.2,0-0.3,0-0.5C226.5,14,175.4,5,125,5S23.5,14,23.5,31.3c0,0.2,0,0.3,0,0.5l0,0 l0,0.2c0,0.4,0.1,0.8,0.2,1.3l25.7,178.6c0.1,7.6,6.7,15.7,17.5,21.7c13.7,7.6,33.7,11.6,58,11.6s44.3-4,58-11.6 c10.8-6,17.3-14.1,17.5-21.7l25.7-178.6c0.1-0.4,0.1-0.8,0.2-1.3L226.4,31.7L226.4,31.7z M125,11.8c57.5,0,94.2,11.4,94.6,19.3 l-0.1,1c-2.6,7.9-38.8,18.5-94.4,18.5S33.2,40,30.6,32.1l-0.1-1C30.8,23.2,67.6,11.8,125,11.8L125,11.8z M56.4,211.5v-0.3L32.1,42.5 c16.6,9.9,54.9,15.1,93,15.1c16.6,0,33.3-1,48.2-2.9v175.9c-9.7,4-25,7.7-48.2,7.7C73.7,238.1,56.4,219.8,56.4,211.5z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDryspellIconWeekend);
export default __webpack_public_path__ + "static/media/dryspell-icon-weekend.834c00031877a6e0346faa42b0244300.svg";
export { ForwardRef as ReactComponent };